module.exports = __webpack_public_path__ + "media/images/OPL 108-39e2c903823f187dd5a9480281412432.png";